import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { EArchType, toothMovement, wasmModule } from "@/gluelayer"
import {
  setCurArch,
  setIsShowExtractedMsg,
  setOpenCollisionCheck,
  setOpenInitialFinal,
} from "@/UDTreat/udTreatSlice"
import { Button, Tooltip } from "@mui/material"
import classNames from "classnames"
import { FC, useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"

interface IProps {
  curArch: string
  isShow: boolean
  setIsShow: (val: boolean) => void
}
const PonticDome: FC<IProps> = ({ isShow, setIsShow, curArch }) => {
  const dispatch = useDispatch()
  const {
    openInitialFinal,
    isShowExtractedMsg,
    openCollisionCheck,
    topLeftViewType,
  } = useAppSelector((state: RootState) => state.udTreatService)

  // 监听牙弓是否开启
  const disabled = useMemo(() => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (hasUpper && hasLower && curArch === "all") {
      return true
    } else {
      return false
    }
  }, [
    wasmModule.getArchModel(EArchType.UpArch),
    wasmModule.getArchModel(EArchType.LowArch),
    curArch,
  ])

  const initView = async (initStatus: boolean) => {
    if (!initStatus) {
      setIsShow(false)
      wasmModule.statusController.SwitchDomePonticMenu(false)

      dispatch(setIsShowExtractedMsg(false))
      // dispatch(setOpenCollisionCheck(true))
      // open Bite Check
      // dispatch(setDisabledBiteCheck(false))
      // dispatch(setOpenBiteCheck(true))
      toothMovement.setIsEnableMoveTooth(true)
      return
    }
    // Close Bite Check
    // dispatch(setDisabledBiteCheck(true))
    // dispatch(setOpenBiteCheck(false))
    if (openCollisionCheck) {
      dispatch(setOpenCollisionCheck(false))
    }
  }

  useEffect(() => {
    if (curArch === "all") {
      dispatch(setCurArch("up"))
    }
    initView(true)
    return () => {
      initView(false)
    }
  }, [])

  useEffect(() => {
    if (isShow) {
      if (!isShowExtractedMsg) {
        dispatch(setIsShowExtractedMsg(true))
      }
    }

    //Initial Final 开启时，默认不显示
    if (!isShow) {
      setIsShow(false)
      if (isShowExtractedMsg) {
        dispatch(setIsShowExtractedMsg(false))
      }
      wasmModule.statusController.SwitchDomePonticMenu(false)
      return
    }
    // 开启Initial Final 模式时，关闭牙弓
    if (openInitialFinal) {
      dispatch(setOpenInitialFinal(false))
    }

    wasmModule.statusController.SwitchDomePonticMenu(isShow)
  }, [isShow, curArch, openInitialFinal])

  return (
    <div className="card-item-body">
      <Tooltip placement="top" title={"Add or remove pontic/dome"} arrow>
        <Button
          className={classNames("btn w-100", {
            "btn-secondary my-btn-secondary": !isShow,
          })}
          variant="contained"
          onClick={() => {
            if (isShow) {
              toothMovement.setIsEnableMoveTooth(true)
            } else {
              toothMovement.setIsEnableMoveTooth(false)
            }
            setIsShow(!isShow)
          }}
        >
          Pontic/Dome
        </Button>
      </Tooltip>
    </div>
  )
}

export default PonticDome
